import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Academies() {
  const [academies, setAcademies] = useState([]);

  useEffect(() => {
    api.get("/academies").then(({ data }) => setAcademies(data)).catch(() => {});
  }, []);

  return (
    <div>
      <section className="relative py-20 px-6 lg:px-8 border-b border-white/10 overflow-hidden">
        <img src="https://images.pexels.com/photos/5616798/pexels-photo-5616798.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] to-black/60" />
        <div className="relative max-w-[1400px] mx-auto text-center">
          <p className="font-mono text-yellow-400 uppercase tracking-widest text-xs">The Paragon Network</p>
          <h1 className="font-heading font-black uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-2">One Team. Multiple Academies.</h1>
          <p className="text-zinc-300 mt-4 max-w-xl mx-auto">Find your Paragon academy and stay connected to the team.</p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {academies.map((a) => (
            <div key={a.id} data-testid={`academy-card-${a.id}`} className="bg-[#121216] border border-white/10 rounded-lg overflow-hidden hover:border-yellow-400/40 transition-colors">
              <div className="aspect-[4/3] bg-[#0A0A0C] flex items-center justify-center p-6">
                <img src={a.main_logo_url || "/paragon-logo.jpeg"} alt={a.name} className="h-24 w-24 rounded-full object-contain opacity-90" />
              </div>
              <div className="p-4 border-t border-white/10">
                <h4 className="font-heading font-bold uppercase text-white leading-tight">{a.name}</h4>
                <p className="font-mono text-[11px] uppercase tracking-wider text-zinc-500 mt-1">
                  {[a.city, a.state].filter(Boolean).join(", ") || "—"}
                  {a.locations?.length > 1 ? ` · ${a.locations.length} locations` : ""}
                </p>
                {!a.uses_master_logo && !a.main_logo_file_id && (
                  <p className="font-mono text-[10px] uppercase text-yellow-400/70 mt-1">Logo pending</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
